import React, { Component } from "react"
import { TextField } from "@material-ui/core"
import moment from "moment"

export default class DateInput extends Component {
    render() {
        const { value, onChange, label, name, disabled, required } = this.props
        return (
            <TextField
                value={value || moment().format("YYYY-MM-DD")}
                onChange={onChange}
                label={`${label}${required ? "*" : ""}`}
                name={name}
                disabled={disabled}
                variant="outlined"
                fullWidth
                style={{ margin: "12px 0" }}
                InputLabelProps={{
                    shrink: true,
                }}
                type="date"
            />
        )
    }
}
